import React from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { node, oneOf, string } from 'prop-types'

function FeeRow({
  label,
  value,
  variant = 'default',
  layout = 'inline',
}) {
  const isDanger = variant === 'danger'
  const isSummary = layout === 'summary'

  const labelClass = classnames(
    'cancel-subscription-modal__fee-label',
    'cgt-text-medium',
    isSummary && 'cgt-text-medium--semi-bold',
    isSummary && isDanger && 'cancel-subscription-modal__fee-label--danger'
  )

  const valueClass = classnames(
    'cancel-subscription-modal__fee-value',
    'cgt-text-medium',
    'cgt-text-medium--semi-bold',
    isDanger && 'cancel-subscription-modal__fee-value--danger'
  )

  const lineClass = isSummary
    ? 'cancel-subscription-modal__fee-summary-line'
    : 'cancel-subscription-modal__fee-line'

  return (
    <div className={lineClass}>
      <span className={labelClass}>{label}</span>
      <span className={valueClass}>{value}</span>
    </div>
  )
}

FeeRow.propTypes = {
  label: node.isRequired,
  value: node.isRequired,
  variant: string,
  layout: oneOf(['inline', 'summary']),
}

export default FeeRow
